import { Col } from 'react-bootstrap';
import ServiceModel from '../../../data/entities/booking/ServiceModel';
import style from '../styles/Service.module.scss';

interface ServiceItemProps {
  service: ServiceModel;
  isBooked: boolean;
  onClick: () => void;
}

const ServiceItem = ({ service, isBooked, onClick } : ServiceItemProps) => {
  const apiBaseUrl = process.env.REACT_APP_API_URL;
  return (
    <Col lg={12} xxl={8}>
      <div
        className={`${style.service} ${isBooked ? style.booked : ''}`}
        onClick={!isBooked ? onClick : undefined}
      >
        <img
          src={`${apiBaseUrl}service/${service.id}/image`}
          alt={service.name}
          className={style.serviceImage}
        />
        <div className="ms-1">
          {service.name}
        </div>
      </div>
    </Col>
  );
};

export default ServiceItem;
